import { kebabCase } from "lodash";

export interface PostItem {
  label: string;
  url: string;
}

export interface PostGroup {
  label: string;
  pages: PostItem[];
}

export function formatPostsByCategory(nodes: any, category: string): PostGroup[] {
  if (!category) return [];

  return nodes
    .find((node: any) => {
      return node.label?.toLowerCase() === category.toLowerCase();
    })
    .categories.map((group) => ({
      ...group,
      pages: group.pages.map((page) => ({
        label: page,
        url: `/${category}/${group.label}/${page}`
          .split("/")
          .map((part) => kebabCase(part))
          .join("/"),
      })),
    }));
}

export function flattenPosts(formattedPosts: PostGroup[]): PostItem[] {
  return formattedPosts.reduce((acc, curr) => {
    return [...acc, ...curr.pages];
  }, []);
}

interface CategoryLink {
  name: string;
  url: string;
}

export function getFirstPostsByCategory(nodes: any): { [category: string]: CategoryLink } {
  const categoryLinks = nodes.reduce((acc: CategoryLink[], curr: any) => {
    const category = kebabCase(curr.label);

    if (!acc[category]) {
      const categorized = formatPostsByCategory(nodes, category);
      const links = flattenPosts(categorized);
      return { ...acc, [category]: links[0] };
    }

    return acc;
  }, {});

  return categoryLinks;
}
